import React from "react";

export const RvaClip = () => {
  return (
    <section className="px-5 md:px-10 py-10" data-testid="rva-clip-section">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 items-center">
        {/* Looping clip in a polaroid card */}
        <div className="crayon-card relative p-4 rotate-[-2deg]">
          <span className="tape" style={{ background: "rgba(232, 116, 44, 0.6)" }} />
          <div className="aspect-square w-full border-4 border-[#1A1A1A] bg-[#FBF3E2] overflow-hidden">
            <video
              src="/video/rva.mp4"
              className="w-full h-full object-cover"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              data-testid="rva-video"
            />
          </div>
          <p className="font-display text-center text-2xl md:text-3xl mt-3 text-[#1A1A1A]">
            live retard cam ✦ RVA
          </p>
        </div>

        {/* Copy */}
        <div className="crayon-card-soft p-6 md:p-8 rotate-1">
          <h2 className="font-display text-4xl md:text-6xl text-[#1A1A1A] leading-tight">
            the <span className="text-[#E8742C]">RVA</span> is broadcasting
          </h2>
          <p className="text-lg md:text-xl text-[#1A1A1A]/80 mt-3">
            certified 24/7 propeller surveillance. you can run, but you can't
            hide from the rva. tune in. send pump prayers. stay retarded.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <span className="sticker" style={{ position: "static", transform: "rotate(-2deg)" }}>
              now broadcasting
            </span>
            <span
              className="sticker"
              style={{
                position: "static",
                transform: "rotate(2deg)",
                background: "#2A9D8F",
                color: "white",
              }}
            >
              live af
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RvaClip;
